<template>
    <div
      v-show="showDisclaimer"
      class="disclaimer"
      :class="{ 'disclaimer--single': isSingle }"
      ref="disclaimerContainer">
        <div class="disclaimer__icon"></div>
        <div class="disclaimer__text">{{disclaimerText}}</div>
    </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Ref, Watch
} from 'vue-property-decorator';
import Manufacturer from '../../models/vehicle/manufacturer';

@Component
export default class BrochureDisclaimerComponent extends Vue {
  @Prop({ default: 'If you select \'Brochure\' we may share your contact details with BMW for them to send a brochure directly to your inbox.' })
  public disclaimerText!: string;

  @Ref('disclaimerContainer')
  public readonly disclaimerContainer!: HTMLDivElement;

  public get manufacturer(): Manufacturer | null {
    return this.$store.getters['vehicleModule/currentManufacturer'];
  }

  public get brochureRequested(): boolean {
    return this.$store.getters['enquiryModule/brochureRequested'];
  }

  public get showDisclaimer(): boolean {
    return this.manufacturer !== null && this.manufacturer.manufacturerId === 7 && this.brochureRequested;
  }

  public isSingle: boolean = false;

  public updateContainerSize() {
    if (this.disclaimerContainer) {
      this.isSingle = this.disclaimerContainer.clientHeight <= 36;
    }
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.updateContainerSize);
  }

  public mounted() {
    this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);
  }
}
</script>
